import { DateTime } from "luxon";
import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { useDispatch } from "react-redux";
import { NavLink, useSearchParams } from "react-router-dom";
import { useAccount, useAccountID } from "../store/account";
import { useCurrentPlan } from "../store/currentPlan";
import { usePlanUpgrades } from "../store/plan-upgrades";
import { usePlans } from "../store/plans";
import { addToast } from "../store/ui";

export default function Checkout() {
    const { data: account } = useAccount();
    const { data: upgrades } = usePlanUpgrades();

    const [queryParams, setQueryParams] = useSearchParams();
    const priceID = queryParams.get("id");
    const purchasing = upgrades ? upgrades.filter(upgrade => upgrade.prices[0].productPriceID == priceID)[0] : null;

    const cancel = () => {
        window.location = `/`;
    };
    const purchase = () => {
        window.location = `/${account.accountID}/checkout/start/${priceID}`;
    };

    return (
        <>
            <Helmet>
                <title>Confirm Purchase</title>
            </Helmet>
            <h1>Confirm Purchase</h1>
            {
                purchasing == null ? ("") : (
                    <>
                        <p>{purchasing.name} for ${purchasing.prices[0].amount / 100}</p>
                        <p>
                            <button onClick={cancel}>Cancel</button>
                            <button onClick={purchase}>Purchase</button>
                        </p>
                    </>
                )
            }
        </>
    );
}
